import { render, staticRenderFns } from "./TimeType.vue?vue&type=template&id=0b2d1e9c&"
import script from "./TimeType.vue?vue&type=script&lang=js&"
export * from "./TimeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2d1e9c')) {
      api.createRecord('0b2d1e9c', component.options)
    } else {
      api.reload('0b2d1e9c', component.options)
    }
    module.hot.accept("./TimeType.vue?vue&type=template&id=0b2d1e9c&", function () {
      api.rerender('0b2d1e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/TimeType.vue"
export default component.exports